"use client";
import React from "react";
import { isFunction } from "utils/lodash";
const useLocalStorage = (key: string, defVal: any) => {
  const isCSR = typeof localStorage !== "undefined";
  const [value, $value] = React.useState(() => {
    let itemVal = defVal;
    try {
      if (isCSR) {
        // Chưa có key (hoặc đã lưu rỗng/null) → dùng giá trị mặc định.
        // Trước đây `|| '""'` parse ra chuỗi rỗng → provinces="" → ô Tỉnh hiện ID thô.
        const str = localStorage.getItem(key);
        const parsed = str === null ? null : JSON.parse(str);
        const empty =
          parsed === null || parsed === "" || (Array.isArray(parsed) && parsed.length === 0);
        itemVal = empty ? defVal : parsed;
        itemVal = isFunction(itemVal) ? itemVal() : itemVal;
      }
    } catch (err) {
      console.log({ "@useLocalStorage:": err });
    }
    return itemVal;
  });
  const setValue = (newVal: any) => {
    try {
      if (isCSR) {
        localStorage.setItem(key, JSON.stringify(newVal));
        $value(newVal);
      }
    } catch (err) {
      console.log({ "@useLocalStorage:": err });
    }
  };
  return [value, setValue];
};
export default useLocalStorage;
